export default __webpack_public_path__ + "static/track-your-stocks-b483689359bdb70cae6c0c851d198c0f.png";